import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useTreeDelete = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (id: number) => http.del(`/objects/${id}`),
  })

  const remove = async (id: number) => {
    try {
      await mutation.mutateAsync(id)

      addSuccess(trs('itf.object_removed'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}
